/**
 * Short relative-time formatter tuned for "Saved …" / "Last seen …" labels.
 * Returns user-friendly strings like "just now", "2 min ago", "at 09:34"
 * (same day) or "Mar 5 at 09:34" (older).
 */
export function formatRelativeShort(when: Date | number, now: Date | number = Date.now()): string {
  const whenMs = typeof when === 'number' ? when : when.getTime();
  const nowMs = typeof now === 'number' ? now : now.getTime();
  const diffSec = Math.max(0, Math.floor((nowMs - whenMs) / 1000));

  if (diffSec < 5) return 'just now';
  if (diffSec < 60) return `${diffSec} sec ago`;

  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin} min ago`;

  const whenDate = new Date(whenMs);
  const nowDate = new Date(nowMs);
  const sameDay =
    whenDate.getFullYear() === nowDate.getFullYear() &&
    whenDate.getMonth() === nowDate.getMonth() &&
    whenDate.getDate() === nowDate.getDate();

  const time = whenDate.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
  if (sameDay) return `at ${time}`;

  const date = whenDate.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  return `${date} at ${time}`;
}
